// Sends Klaviyo an "Added to Cart" event after a successful add from the product form.
// Replaces the live theme's custom-liquid script. Uses Klaviyo's standard Added to Cart
// properties so abandoned-cart flows and their dynamic product blocks keep working.
// Does nothing when Klaviyo's onsite script isn't loaded.

function klaviyoQueue() {
  if (window.klaviyo && typeof window.klaviyo.push === 'function') return window.klaviyo;
  window._learnq = window._learnq || [];
  return window._learnq;
}

function money(cents) {
  return Math.round(Number(cents || 0)) / 100;
}

function variantNumericId(id) {
  const match = String(id || '').match(/(\d+)$/);
  return match ? match[1] : '';
}

async function trackAddedToCart(event) {
  if (!window.klaviyo && !window._learnq) return;

  const variantId = variantNumericId(event.detail?.variantId);
  const quantity = Number(event.detail?.quantity) || 1;

  try {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return;
    const cart = await response.json();

    const added = cart.items.find((item) => String(item.variant_id) === variantId) || cart.items[0];
    if (!added) return;

    const origin = window.location.origin;
    const properties = {
      $value: money(cart.total_price),
      AddedItemProductName: added.product_title,
      AddedItemProductID: String(added.product_id),
      AddedItemVariantID: String(added.variant_id),
      AddedItemSKU: added.sku || '',
      AddedItemCategories: added.product_type ? [added.product_type] : [],
      AddedItemImageURL: added.image || '',
      AddedItemURL: added.url ? origin + added.url : '',
      AddedItemPrice: money(added.final_price),
      AddedItemQuantity: quantity,
      ItemNames: cart.items.map((item) => item.product_title),
      CheckoutURL: `${origin}/checkout`,
      Items: cart.items.map((item) => ({
        ProductID: String(item.product_id),
        VariantID: String(item.variant_id),
        SKU: item.sku || '',
        ProductName: item.product_title,
        Quantity: item.quantity,
        ItemPrice: money(item.final_price),
        RowTotal: money(item.final_line_price),
        ProductURL: item.url ? origin + item.url : '',
        ImageURL: item.image || '',
        ProductCategories: item.product_type ? [item.product_type] : [],
      })),
    };

    klaviyoQueue().push(['track', 'Added to Cart', properties]);
  } catch {
    // Tracking must never interfere with shopping.
  }
}

document.addEventListener('product-form:added', trackAddedToCart);
